import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EnumMicroDroits } from "../../modules/administration/models/micro.droits";
import { SessionService } from "../../modules/administration/services/session.service";


/**
 * Check if the user, with its currently connected session, has access to
 * a specific action.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private readonly session: SessionService) { }

  /**
   * Check if the user, with the currently connected session, has access to
   * an action.
   * 
   * Automatically update when the session is updated to a new profile.
   * 
   * @param potentialMicroRights a list of micro-rights that are sufficient
   * to have access to the action.
   * @returns an Observable of boolean which provide `true` when the current
   * active session possess one (or more) of the micro-rights in
   * `potentialMicroRights`.
   */
  public hasAnyMicroRightIn(potentialMicroRights: Array<EnumMicroDroits>): Observable<boolean> {
    return this.session.activeProfile.pipe(
      map(profile => profile?.microDroits.microDroits.some(
        microDroit => potentialMicroRights.includes(microDroit))
      ));
  }
}
